import ComparePage from '../views/Compare/ComparePage.jsx'
import LandingPage from '../views/LandingPage/LandingPage.jsx'
import MarketSharePage from '../views/MarketShare/MarketSharePage.jsx'
import TrendsPage from '../views/Trends/TrendsPage.jsx'
import TagsLandingPage from '../views/Tags/TagsLandingPage.jsx'
import TagsGameComparePage from '../views/Tags/TagsGameComparePage.jsx'
import TagDetailPage from '../views/Tags/TagDetailPage.jsx'

// Helper to create both regular and embed routes
function withEmbed(path, name, component) {
  return [
    { path: path, name: name, component: component },
    { path: `/embed${path}`, name: name, component: component }
  ]
}

var indexRoutes = [
  { path: '/', name: 'LandingPage', component: LandingPage },
  ...withEmbed('/compare-page/:ids/:section?', 'ComparePage', ComparePage),
  ...withEmbed('/player-share/:section?', 'MarketSharePage', MarketSharePage),
  ...withEmbed('/trends/:section?', 'TrendsPage', TrendsPage),
  ...withEmbed('/tags/:section?', 'TagsLandingPage', TagsLandingPage),
  ...withEmbed('/tag-compare/:ids?/:section?', 'TagsGameComparePage', TagsGameComparePage),
  ...withEmbed('/tag-detail/:id?/:tags?', 'TagDetailPage', TagDetailPage)
]

export default indexRoutes
